export default function FeteDuJour({ partyOfTheDay }) {

  return (
    <div className="box-section-fete-bas">
      <div className="card3d-fete-container">
        <div className="fete-card3d">
          <h4 className="titre-fete">Aujourd'hui votre boutique fête : <a className="titre-text-fete">{partyOfTheDay}</a></h4>
          <h4 className="titre-text-fete-mobil">{partyOfTheDay}</h4>
        </div>
      </div>
    </div>
  );
}